import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3dcb5750"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "input-select-content"
};
const _hoisted_3 = {
  class: "btn-content"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFilterBlock',
  emits: ['filterSubmit'],
  setup(__props, {
    emit
  }) {
    const searchName = ref('');
    const filterSubmit = () => {
      emit('filterSubmit', {
        condition: searchName.value
      });
    };
    const initSearch = () => {
      searchName.value = '';
      filterSubmit();
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_input, {
        placeholder: "支持账号/用户名搜索",
        value: searchName.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => searchName.value = $event),
        valueModifiers: {
          trim: true
        },
        onPressEnter: filterSubmit
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_button, {
        onClick: initSearch
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])]);
    };
  }
});